import mutations from './remUserMutations';
import actions from './remUserAction';
import getters from './remUserGetters';

const state = {
  remRole: '',
  userPrmsYn: '',
  infraManagerYn: '',
  divisionCd: '',
};

export default {
  state,
  mutations,
  actions,
  getters,
};



// WEBPACK FOOTER //
// ./src/vuex/rem/user/remUserStore.js